import { useSelector } from 'react-redux';
import CartItem from './CartItem';
import PriceSidebar from './PriceSidebar';
import Stepper from './Stepper';
import { useNavigate } from 'react-router-dom';
import MetaData from '../Layouts/MetaData';
import useCartPricing from '../../utils/useCartPricing';
import { useLang, uiText } from '../../utils/i18n';

const OrderConfirm = () => {

    const navigate = useNavigate();
    const { cartItems } = useSelector((state) => state.cart);
    const { user } = useSelector((state) => state.user);
    const pricing = useCartPricing(cartItems);
    const { lang } = useLang();

    return (
        <>
        <MetaData title="YourStore: Order Confirmation" />

        <main className="w-full mt-20">

            {/* <!-- row --> */}
            <div className="flex flex-col sm:flex-row gap-3.5 w-full sm:w-11/12 mt-0 sm:mt-4 m-auto sm:mb-7">

                {/* <!-- cart column --> */}
                <div className="flex-1">

                    <Stepper activeStep={2}>
                        <div className="w-full bg-white">
                            {cartItems?.map((item, i) => (
                                <CartItem {...item} inCart={false} key={i} offerLine={pricing?.items.find((p) => p.product === item.product)} />
                            ))}
                        </div>
                        <div className="flex justify-between items-center mt-4 bg-white px-6 py-3 rounded-b-sm gap-3">
                            <button onClick={() => navigate('/shipping')} className="text-sm font-medium text-gray-600 hover:text-primary-blue flex items-center gap-1 whitespace-nowrap">
                                &larr; {uiText('backWord', lang)}
                            </button>
                            <p className="text-sm hidden sm:block">{uiText('orderConfirmEmailNote', lang)} <span className="font-medium">{user.email}</span></p>
                            <button onClick={() => { navigate('/process/payment') }} className="bg-primary-orange px-6 py-2 text-white font-medium rounded-sm shadow hover:shadow-lg uppercase whitespace-nowrap">{uiText('continueWord', lang)}</button>
                        </div>
                    </Stepper>
                </div>

                <PriceSidebar cartItems={cartItems} pricing={pricing} />
            </div>
        </main>
        </>
    );
};

export default OrderConfirm;
